import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useDispatch, useSelector } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { State } from '../types/state'
import { Alert } from '@mui/material'
import DialogContentText from '@material-ui/core/DialogContentText'
import { SelectedSubject } from '../types/selected-subject'

interface ConfirmSelectionDialogProps {
  selectedSubjects: SelectedSubject[]
  handleDialog: (b: boolean) => void
}

const ConfirmSelectionDialog = ({
  selectedSubjects,
  handleDialog
}: ConfirmSelectionDialogProps): JSX.Element => {
  const { subjects } = useSelector((state: State) => state.user)
  const dispatch = useDispatch()
  const requestMaker = useRequests()

  const handleSubmit = useCallback(async (): Promise<void> => {
    handleDialog(false)
    try {
      const subjectSelection = selectedSubjects.map((s, index) => ({
        index: index + 1,
        subjectId: s.subjectId,
        isHighLevel: s.isHighLevel
      }))
      await requestMaker.updateSubjectSelection(subjectSelection)
      dispatch(RefreshActions.refreshUserState())
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Succesfully updated subject selection'
        })
      )
    } catch (e) {
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Error - try again later'
        })
      )
    }
  }, [requestMaker, dispatch])

  return (
    <div>
      <Dialog open onClose={() => handleDialog(false)}>
        <form>
          <DialogTitle>Requirements</DialogTitle>
          <DialogContent>
            {selectedSubjects.map((sub, i) => {
              const currentSubject = subjects.find(s => sub.subjectId === s.id)
              return (
                currentSubject?.qualification && (
                  <Alert key={i} severity='info'>
                    {`${currentSubject?.name} - ${currentSubject?.qualification}`}
                  </Alert>
                )
              )
            })}
            {/* <DialogContentText
              style={{
                marginTop: '5vh',
                fontSize: '30px',
                color: '#383838'
              }}
            >
              I MEET THE REQUIREMENTS
            </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleDialog(false)}>NO</Button>
            <Button onClick={async () => await handleSubmit()}>
              I MEET THE REQUIREMENTS
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default ConfirmSelectionDialog
